
import React from 'react';
import { Spinner as FabricSpinner } from 'office-ui-fabric-react/lib/Spinner';

const Spinner = (props) => {

    const styles = {
        circle: {
            borderWidth: props.width,
            width: props.size,
            height: props.size
        },
        label: {
            ...(props.labelStyle || {})
        }
    };

    return (
        <FabricSpinner
            label={props.title}
            labelPosition={props.labelPosition}
            styles={styles}
        />
    )
}

export default Spinner;
